import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import axios from "axios";
import { CalendarDays } from "lucide-react";
import { NEWS } from "@/components/laneeka/data";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const imgSrc = (src) => (src && src.startsWith("/api") ? `${process.env.REACT_APP_BACKEND_URL}${src}` : src);

export default function NewsPage() {
  const [posts, setPosts] = useState(null);

  useEffect(() => {
    axios
      .get(`${API}/news`)
      .then((r) => setPosts(r.data))
      .catch(() => setPosts(NEWS));
  }, []);

  return (
    <main data-testid="news-page" className="pt-[108px]">
      <section className="bg-slate-950 border-b border-slate-800 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-xs font-semibold uppercase tracking-widest text-blue-400 mb-3">Updates</p>
          <h1 className="text-3xl sm:text-4xl font-bold tracking-tight text-white">News &amp; Announcements</h1>
          <p className="mt-3 text-slate-400 max-w-2xl">
            Company updates, milestones and announcements from Laneeka International.
          </p>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {posts === null && <p className="text-slate-500 col-span-full">Loading news…</p>}
          {posts && posts.length === 0 && <p className="text-slate-500 col-span-full">No news published yet.</p>}
          {posts && posts.map((n, i) => (
            <motion.article
              key={n.id || i}
              data-testid={`news-card-${i}`}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.45, delay: (i % 3) * 0.06 }}
              className="border border-slate-200 rounded-xl overflow-hidden hover:shadow-md transition-shadow bg-white"
            >
              {n.image && <img src={imgSrc(n.image)} alt={n.title} loading="lazy" className="w-full aspect-[16/10] object-cover" />}
              <div className="p-5">
                <p className="flex items-center gap-1.5 text-xs text-slate-500 mb-2">
                  <CalendarDays className="w-3.5 h-3.5" /> {n.date}
                </p>
                <h3 className="font-semibold text-slate-900 leading-snug">{n.title}</h3>
                <p className="mt-2 text-sm text-slate-600 leading-relaxed">{n.excerpt}</p>
              </div>
            </motion.article>
          ))}
        </div>
      </section>
    </main>
  );
}
